export default "__VITE_ASSET__B6ci4rh3__"